import { createClient } from "react-fetching-library";

export const client = createClient();

export async function httpGet<T>(endpoint: string) {
	return client.query<T>({
		method: "GET",
		headers: createHeaders(),
		endpoint: endpoint,
		responseType: "json",
	});
}

export async function httpPost<T>(endpoint: string, jsonBody: any) {
	return client.query<T>({
		method: "POST",
		headers: createHeaders(),
		body: jsonBody,
		endpoint: endpoint,
		responseType: "json",
	});
}

function createHeaders() {
	return {
		"Accept": "application/json",
		"Content-Type": "application/json",
	};
}
